import { Module } from 'vuex';
import { RecSettingState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: RecSettingState = {
    recSetting: undefined,
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const recSetting: Module<RecSettingState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
